import './core'
import { Mobile, Viewport, Accordion, Tabs, Scrollbar, Navigation, iOS, Android, TRANSITION_END, MOUSEWHEEL } from './core'
import './modules/header'
import './modules/expertises'
import './modules/filters'
import './modules/grid-team'
import './modules/home-hero'
import './modules/related-projects'
import './modules/read-more'
import './modules/picture-plus'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    scroller: $(window).ScrollEvents(),
    news_scroller: undefined,
    is_front_page: $('body').hasClass('front-page'),
    navigation: undefined,
    getOffset: function(px) {
      if ($(window).width() < 1600) {
        px *= (14 / 16)
      } else if ($(window).width() < 1100) {
        px *= (12 / 14)
      }
      return px
    },
  }

  /* Main scrollbar */
  if (!iOS() && !Android()) {
    /* Main scrollbar */
    $.mlmi.scrollbar = new Scrollbar($('body'))
    $.mlmi.scroller = $('body > .scroller').ScrollEvents()
    $('html, body').addClass('has-scrollbars')
  } else {
    $('html, body').addClass('no-scrollbars')
    $('html').removeClass('no-touch').addClass('has-touch')
  }

  function getScroller() {
    if ($.mlmi.scroller.hasClass('scroller')) {
      return $.mlmi.scroller
    }
    return $('html, body')
  }

  function getNewsScroller() {
    if ($.mlmi.news_scroller != undefined && $.mlmi.news_scroller.hasClass('scroller')) {
      return $.mlmi.news_scroller
    }
    return $('.news__background').ScrollEvents()
  }

  /* Read more */
  $('.project__content .read-more').each(function() {
    $(this).ReadMore()
  })

  /* Header */
  $('.header').each(function() {
    $(this).Header()
  })

  /* Tabs */
  if ($('.tabs--expertise').length) {
    Accordion.init() // for mobile
    if ($.mlmi.mobile.isMobile && window.location.hash) {
      $('.accordion__panel-content[data-expertise="' + window.location.hash.replace('#', '') + '"]').closest('.js-accordion__item').find('.accordion__header').trigger('click')
    }
    $('.accordion__header').on('click', function() {
      if ($(this).attr('aria-expanded') == 'false') {
        window.location.hash = $(this).closest('.accordion__item').find('.accordion__panel-content').attr('data-expertise')
      } else if ('history' in window) {
        history.pushState('', document.title, window.location.pathname + window.location.search)
      } else {
        window.location.hash = ''
      }
    })
    let firstTab = $('.tabs--expertise .tabs__item').first().attr('id').replace('tab-', '')
    if (window.location.hash && window.location.hash != '#' + firstTab) {
      $('#panel-' + firstTab).prop('hidden', true)
      $('#tab-' + firstTab).attr('aria-selected', 'false')
      $('#panel-' + window.location.hash.replace('#', '')).prop('hidden', false)
      $('#tab-' + window.location.hash.replace('#', '')).attr('aria-selected', 'true')
    }
  }
  $(window).on('tab_changed', function(e, tabset) {
    if (!$.mlmi.mobile.isMobile) {
      getScroller().scrollTo(0, 450, 5, 'easeInOutQuart')
    }
  })
  $(window).on('tab_transition_end', function(e, tabset) {
    if ($.mlmi.mobile.isMobile) {
      tabset.closest('.accordion__panel').data('accordion-panel').sizer()
    }
  })
  Tabs.init({
    changeHash: true,
  })
  $('.tabs--expertise').each(function() {
    $(this).Expertises()
  })

  if ($('.go-down').length) {
    $('.go-down').on('click', function() {
      let target = $('.header')
      if ($.mlmi.mobile.isMobile) {
        target = $('main .page-section .container').first()
      }
      getScroller().scrollTo(target.offset().top, 450, 4, 'easeInOutQuart')
    })
    $.mlmi.scroller.add(function(top) {
      if (top > 100 && !$('.go-down').hasClass('go-down--hidden')) {
        $('.go-down').addClass('go-down--hidden')
      }
    })
  }

  /* Grids */
  $('.grid--style--team .card-team').each(function() {
    $(this).GridTeamItem()
  })

  /* Filters */
  $('.filters').each(function() {
    $(this).Filters()
  })

  /* Footer */
  $(window).on('resize load orientationchange', function() {
    $('.footer-spacer').height($('footer').outerHeight(false) + 'px');
  })
  $('.footer-spacer').height($('footer').outerHeight(false) + 'px');

  /* Fixed column */
  $('.fixed-column > .text-content').each(function() {
    let element = $(this),
    bottomBlocker = $(this).closest('.row').next()
    element.FixedContent({
      topBlocker: null,
      limitFromTop: 32,
      bottomBlocker: bottomBlocker,
      useTransform: true,
      normalClass: 'status-normal',
      fixedClass: 'status-fixed',
    }).on('content_fixed', function(e) {
      clearTimeout(element.fixed_timeout)
      element.fixed_timeout = setTimeout(function() {
        $(e.target).css('pointer-events', '')
      }, 250)
      $(e.target).css('pointer-events', 'none')
    })
  })

  /* Project intro */
  if ($('.project__intro > .text-content').length > 0 && $('.actions-durables').length == 0) {
    $('.project__intro > .text-content').each(function() {
      let element = $(this),
      bottomBlocker = $('.project__gallery, .project__awards, .project__share').first()
      element.FixedContent({
        topBlocker: null,
        limitFromTop: 32,
        bottomBlocker: bottomBlocker,
        useTransform: true,
        normalClass: 'status-normal',
        fixedClass: 'status-fixed',
      }).on('content_fixed', function(e) {
        clearTimeout(element.fixed_timeout)
        element.fixed_timeout = setTimeout(function() {
          $(e.target).css('pointer-events', '')
        }, 250)
        $(e.target).css('pointer-events', 'none')
      })
    })
  }

  /* Related btn */
  $('.project__related-btn__label').each(function() {
    $(this).FixedContent({
      topBlocker: null,
      limitFromTop: 0,
      bottomBlocker: $('.footer-spacer'),
      useTransform: false,
      normalClass: 'status-normal',
      fixedClass: 'status-fixed',
    })
  })

  /* Home hero */
  $('.home-hero:not(.home-hero--selected)').remove()
  $('.home-hero--selected').each(function() {
    $(this).HomeHero()
    new Viewport({
      selector: '.home-hero--selected',
      updateDynamically: false,
      mobile: false,
    })
  })

  /* Fixed menu */
  $('.tabs--expertise .tabs__items').each(function() {
    let element = $(this)
    element.FixedContent({
      topBlocker: null,
      limitFromTop: 32,
      bottomBlocker: $('.footer-spacer'),
      useTransform: true,
    }).on('content_fixed', function(e) {
      clearTimeout(element.fixed_timeout)
      element.fixed_timeout = setTimeout(function() {
        $(e.target).css('pointer-events', '')
      }, 250)
      $(e.target).css('pointer-events', 'none')
    })
  })
  function positionExpertiseItems() {
    $('.tabs--expertise .tabs__list').each(function() {
      let tabs_list = $(this)
      tabs_list.css({
        position: '',
        left: '',
      })
      if (!$.mlmi.mobile.isMobile) {
        tabs_list.css({
          position: 'relative',
          left: (parseFloat($('.header > .container').css('padding-left')) - $('.tabs--expertise .tabs__list').offset().left) + 'px',
        })
      }
    })
  }
  $(window).on('load resize orientationchange', positionExpertiseItems)
  positionExpertiseItems()
  $.mlmi.scroller.trigger('scroll')

  /* Menu aligned */
  $('.menu-aligned').each(function() {
    var column_content = $(this).find('.text-content')
    function alignColumnWithMenu() {
      column_content.css('left', '')
      column_content.css('left', ($('.header__menu').offset().left - column_content.offset().left) + 'px')
    }
    $(window).on('resize orientationchange load', alignColumnWithMenu)
    alignColumnWithMenu()
  })

  /* Logo aligned */
  $('.logo-aligned').each(function() {
    var column_content = $(this).find('.text-content')
    function alignColumnWithLogo() {
      column_content.css('left', '')
      column_content.css('left', ($('.header__brand').offset().left - column_content.offset().left) + 'px')
    }
    $(window).on('resize orientationchange load', alignColumnWithLogo)
    alignColumnWithLogo()
  })

  /* Inline shapes */
  $('.inline-shape').each(function(index, el) {
    let $el = $(el)
    setTimeout(function() {
      $el.addClass('inline-shape--visible')
    }, 750 + index * 35)
  })

  /* Hover on cards */
  let newsZ = 2
  $('.grid--style--news .grid__item').each(function() {
    $(this).on('mouseenter', function() {
      $(this).css('z-index', newsZ++)
    })
  })

  /* Scroll down links */
  function scrollDownLinks(scope) {
    scope.find('a[href^="#"]:not(.tabs--expertise a)').each(function() {
      $(this).off('click').on('click', function() {
        let anchor_name = $(this).attr('href').substr(1)
        if ($.mlmi.mobile.isMobile && $('.accordion a[name="' + anchor_name + '"]').length) {
          let target = $('.accordion a[name="' + anchor_name + '"]'),
          targeTop = target.offset().top - ($.mlmi.mobile.isMobile ? 67 : $.mlmi.getOffset(80))
          getScroller().scrollTo(targeTop, 450, 5, 'easeInOutQuart')
          return false;
        } else if ($('.news__wrapper #' + anchor_name).length) {
          let target = $('#' + anchor_name),
          targetTop = target.offset().top + getNewsScroller().scrollTop() - ($.mlmi.mobile.isMobile ? 20 : $.mlmi.getOffset(80))
          if ($(this).data('case-study')) {
            target = target.closest('.accordion__item')
            if (target.find('.accordion__header').attr('aria-expanded') === 'false') {
              target.find('.accordion__header').trigger('click')
            }
            targetTop = target.offset().top + getNewsScroller().scrollTop() - 20
          }
          getNewsScroller().scrollTo(targetTop, 450, 5, 'easeInOutQuart')
          return false
        } else if ($('#' + anchor_name).length) {
          let target = $('#' + anchor_name),
          targetTop = target.offset().top + getScroller().scrollTop() - ($.mlmi.mobile.isMobile ? 20 : $.mlmi.getOffset(80))
          getScroller().scrollTo(targetTop, 450, 5, 'easeInOutQuart')
          return false
        }
      })
    })
  }
  scrollDownLinks($('body'))

  if ($('.dynamic-shape').length) {
    gsap.registerPlugin(ScrollTrigger)

    /* Shape animations helper */
    function setTranslate(selector, start, end, scrub) {
      if (scrub == undefined) { scrub = 1 }
      gsap.set(selector, {
        y: start,
      })
      gsap.to(selector, {
        y: end,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: selector,
          end: 'bottom 0%',
          scrub: scrub,
          scroller: $.mlmi.scroller,
        },
      })
    }

    function setFadeIn(selector, duration, delay) {
      if (duration == undefined) { duration = .75 }
      if (delay == undefined) { delay = 0 }
      gsap.set(selector, { opacity: 0, y: '+=80px' })
      gsap.to(selector, {
        opacity: 1,
        y: 0,
        scrollTrigger: selector,
        duration: duration,
        delay: delay,
      })
    }

    /* Add animations */
    if ($('.dynamic-shape[data-name="BC2_forme-carrieres_1"]').length) {
      gsap.to('.dynamic-shape[data-name="BC2_forme-carrieres_1"] svg', {
        y: '-150%',
        scrollTrigger: {
          scrub: true,
          scroller: $.mlmi.scroller,
        },
      })
      setTranslate('.dynamic-shape[data-name="BC2_forme-carrieres_2"] svg', '10%', '-10%', .75);
      setTranslate('.dynamic-shape[data-name="BC2_forme-carrieres_3"] svg', '10%', '-10%', .75);
    }
  }

  /* Related projects */
  $('.related-projects').each(function() {
    $(this).RelatedProjects()
  })

  /* Show content */
  requestAnimationFrame(function() {
    $('body').addClass('--fade-in')
  })

  /* News init */
  function initializeNews() {
    /* Main scrollbar */
    if (!iOS() && !Android()) {
      if ($('.news__wrapper').length && !$('.news__wrapper').hasClass('scroller__container')) {
        new Scrollbar($('.news__wrapper'))
        $.mlmi.news_scroller = $('.news__wrapper > .scroller').ScrollEvents()
      }
    }

    /* Scroll down effect */
    if ($('.news__wrapper').length) {
      let is_news_scrolled_down = false
      getNewsScroller().add(function(top, direction) {
        /* Background change */
        if (direction == 'down' && top > $(window).height() / 2 && !is_news_scrolled_down) {
          is_news_scrolled_down = true
          getNewsScroller().find('.news').addClass('news--bg-scrolled')
        } else if (direction == 'up' && top < $(window).height() / 2 && is_news_scrolled_down) {
          is_news_scrolled_down = false
          getNewsScroller().find('.news').removeClass('news--bg-scrolled')
        }

        /* Chapters */
        if (!$.mlmi.mobile.isMobile && $('.chapter__anchor-link').length) {
          let currentChapter = undefined
          $('.chapter__anchor-link--current').removeClass('chapter__anchor-link--current')
          $('.news h2[id]').each(function() {
            if (currentChapter == undefined || ($(this).offset().top > currentChapter.offset().top && $(this).offset().top < $(window).height() / 2)) {
              currentChapter = $(this)
            }
          })
          $('.sidebar a[href="#' + currentChapter.attr('id') + '"]').addClass('chapter__anchor-link--current')
        }
      })

      /* Background click closes */
      $('.news__background').on('click', function(e) {
        if (e.target == e.currentTarget && !$('.picture-plus-item__bubble[aria-hidden="false"]').length) {
          $('.news__close-btn').trigger('click')
        }
      })

      /* Fixed sidebar */
      $('.sidebar > .text-content').each(function() {
        $(this).FixedContent({
          topBlocker: $('.news__date'),
          limitFromTop: 1,
          bottomBlocker: $('.sidebar-blocker'),
          scroller: getNewsScroller(),
          useTransform: true,
          normalClass: 'status-normal',
          fixedClass: 'status-fixed',
        })
      })
    }

    /* Scroll down links */
    scrollDownLinks($('.news__wrapper'))

    /* Mobile chapters */
    let firstMobileDisplay = true
    $.mlmi.mobile.add(function() {
      if (firstMobileDisplay) {
        firstMobileDisplay = false
        if ($('.news__chapters').length) {
          $('.news__mobile-chapters .accordion__panel-content').append($('.news__chapters').clone())
          scrollDownLinks($('.news__mobile-chapters').show())
        }
      }
    }, function() {
      //
    })

    /* Picture plus */
    $('.picture-plus').each(function() {
      $(this).PicturePlus()
    })

    /* Close news */
    $('.news__close-btn').on('click', function(e) {
      e.preventDefault()
      $('.news__wrapper').removeClass('news__wrapper--visible').on(TRANSITION_END, function(e) {
        if (e.target == e.currentTarget) {
          $('.news__wrapper').addClass('d-none')
        }
        $.mlmi.navigation.pushState($.mlmi.navigation.getStateObject(), $('.app').data('title'), $('.app').data('permalink'))
        document.title = $('.app').data('title')
      })
    })

    /* Accordions */
    Accordion.init($('.news'))

    /* Tabs */
    Tabs.init({
      changeHash: false,
    })

    /* Display */
    requestAnimationFrame(function() {
      $('.news__wrapper').addClass('news__wrapper--visible')
    })
  }
  $(window).on('load page_load', initializeNews)
  initializeNews()

  /* Navigation */
  $.mlmi.navigation = new Navigation({
    useTransition: false,
    selectors: {
      pageContent: '.news__wrapper',
      pageTarget: '.news__wrapper',
      links: 'a.card-news',
    },
    // on: {
    //   beforeRegisterLinks: undefined,
    //   linkClicked: undefined,
    //   popState: undefined,
    // },
    // filter: {
    //   popState: undefined,
    // }
  })
})
